import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Subject, Subscription, forkJoin, fromEvent } from 'rxjs';
import { startWith, takeUntil } from 'rxjs';
import { AppLoginService } from '../app-login.service';
import { ManageProfileService } from '@app/pages/manage-profile/manage-profile.service';
import { HttpService } from '@app/@core/services/http.service';
import { TOAST_CODES } from '@app/@core/entities/notification-codes.constant';
import { VALIDATORS } from '@app/@core/entities/validators.constant';
import { FormatNumberPipe } from '@app/@core/pipes/format-number.pipe';
import { LocalService } from '@app/@core/services/local.service';

@Component({
  standalone: false,
  selector: 'app-forgot-password-phone',
  templateUrl: './forgot-password-phone.component.html',
  styleUrls: ['./forgot-password-phone.component.scss']
})
export class ForgotPasswordPhoneComponent implements OnInit, OnDestroy {

  findAccountForm: FormGroup;
  isSubmitted = false;
  emailSent = false;
  isMobile = false;
  logoPath = 'assets/images/edu-logo.svg';
  resizeObservable$: Subscription | undefined;
  isButtonDisabled = true;
  toastMessageArray:any = []
  toastMessage:string | null = null
  showToastDiv:boolean = false
  isFormatting:boolean = false
  toastType:string
  private destroy$ = new Subject<void>()
    constructor(private readonly fb: FormBuilder, private readonly router: Router, private readonly appLoginService: AppLoginService,
       private readonly manageProfileService: ManageProfileService , private httpService:HttpService , private formatNumberPipe:FormatNumberPipe,
      private sessionStorage: LocalService,) {}


   ngOnInit(): void {
    this.initForm();
    this.setupResponsiveImage();
  }

  ngOnDestroy(): void {
    if (this.resizeObservable$) {
      this.resizeObservable$.unsubscribe();
    }

    this.destroy$.next();
    this.destroy$.complete()
  }

  async getToastMessage(){
    const storedToastMessage = localStorage.getItem('toastMessages')
    if(storedToastMessage) {
      this.toastMessageArray = JSON.parse(storedToastMessage)
      return
    }
    forkJoin([
      this.httpService.get('/domain/lookup?requestType=TOAST MESSAGES'),
      this.httpService.get('/domain/lookup?requestType=GENERIC MESSAGES'),
    ])
    .pipe(takeUntil(this.destroy$))
    .subscribe({
      next:(items : any)=>{
        this.toastMessageArray = items[0]
      }
    })
  }

  setupResponsiveImage(): void {
    this.resizeObservable$ = fromEvent(window, 'resize').pipe(startWith({} as Event))
      .subscribe(() => {
        this.isMobile = window.innerWidth < 768;
        this.updateLogoPath();
      });

    this.isMobile = window.innerWidth < 768;
    this.updateLogoPath();
  }

  updateLogoPath(): void {
    this.logoPath = this.isMobile
      ? 'assets/images/cardy-ai/mobile-logo.svg'
      : 'assets/images/edu-logo.svg';
  }

  initForm(): void {
    this.findAccountForm = this.fb.group({
      phone: [
        '',
        [
          Validators.required,
          Validators.pattern(VALIDATORS.MAX_PHONE_NUMBER_PATTERN)
        ]
      ]
    });

    // Monitor phone field changes to enable/disable button
    this.findAccountForm.get('phone')?.valueChanges.subscribe(() => {
      this.isButtonDisabled = !this.findAccountForm.get('phone')?.valid;
    });
  }

  get formControls() {
    return this.findAccountForm.controls;
  }

  onSubmit(): void {
  this.isSubmitted = true;
  if (this.findAccountForm.valid) {
    this.isButtonDisabled = true;
  let phoneValue = this.findAccountForm.get('phone')?.value;
  // Remove all non-digit characters
  let convertedPhone = phoneValue.replace(/\D/g, '');

    this.manageProfileService.checkPhoneExists(convertedPhone).subscribe({
      next: (response) => {
        // Adjusted for your API response structure
        if (response.status === 'success' && response.data && response.data.exists) {
          // Phone exists, proceed
          //show toast message
            const toast = this.toastMessageArray?.data?.find((t:any) => t.key === TOAST_CODES.PHONE_EXIST );
            const message = (toast?.value)
            this.showToast(message , response.data.exists)
          setTimeout(() => {
            this.emailSent = true;
          this.phoneSending();
          }, 3000);
        } else {
          // Phone does not exist, show error
          const toast = this.toastMessageArray?.data?.find((t:any) => t.key === TOAST_CODES.PHONE_NOT_EXIST);
            const message = (toast?.value || 'T0046: Phone Number not found. Make sure your Phone Number is registered before continuing.')
            this.showToast(message , response.data.exists)
          this.isButtonDisabled = false;
          this.findAccountForm.get('phone')?.setErrors({ notFound: true });
        }
      },
      error: () => {
        this.isButtonDisabled = false;
        this.findAccountForm.get('phone')?.setErrors({ serverError: true });
      }
    });
  }
}

showToast(message:string , type:string){
  this.toastMessage = message
  this.toastType = type
  this.showToastDiv = true

  setTimeout(() => {
    this.showToastDiv = false
  }, 3000);
}

phoneSending(): void {
  let phoneValue = this.findAccountForm.get('phone')?.value;
  // Remove all non-digit characters
  const digitsOnly = phoneValue.replace(/\D/g, '');

  // Store phone in sessionStorage if needed
  this.sessionStorage.setItem('Phone', digitsOnly);

  // Navigate to the next page with query params
  this.router.navigate(
    ['/verify-forgot-password'],
    {
      queryParams: {
        from: 'forgot-password-phone',
        phone: digitsOnly,
        // email: hardcodedEmail
      }
    }
  );
}
  cancel(): void {
       this.router.navigate(['app-login/find-account']);
     }

formatPhoneNumber(event:any){
  let input = event.target.value
  const formattedValue = this.formatNumberPipe.transform(input)
  this.findAccountForm.get('phone')?.setValue(formattedValue, { emitEvent: false });
}
}
